export const itemPopulationLevelNone = {
  labels: false,
  modifiers: false,
  modifierGroups: false,
  priceVariants: false
};
export const modifierGroupPopulationLevelNone = {
  modifiers: false
};
export const CREATE_ITEM_SOURCE = {
  duplicateItem: 'duplicate_item',
  createItem: 'user_action',
  duplicateMenu: 'duplicate_menu'
};
//# sourceMappingURL=consts.js.map